import { createKeyAtPath } from '@/utilities/db-helpers'
import sheet from './sheet'

import fb from '@/utilities/firebase-config'
const db = fb.database() // alias here so firebase-mock works

export default {
  namespaced: true,

  modules: {
    sheet,
  },

  getters: {
    combatantById() {
      return async combatantId => {
        const snapshot = await db
          .ref(`/combatants/${combatantId}`)
          .once(`value`)
        return snapshot.val()
      }
    },

    battleIds() {
      return async id => {
        const snapshot = await db.ref(`/combatants/${id}/battles`).once(`value`)
        return snapshot.val()
      }
    },
  },

  actions: {
    create(
      // eslint-disable-next-line
      { dispatch, rootGetters: {[`battles/battle`]: battle} },
      data
    ) {
      const id = createKeyAtPath(`/combatants`)
      const meta = { ...data, id }
      const battles = { [battle]: true }
      const updates = { [`/combatants/${id}`]: { ...meta, battles } }

      if (battle) {
        updates[`/battleCombatants/${battle}/${id}`] = {
          meta: { id },
          initiative: 0,
          advantage: 0,
        }
      }

      return dispatch(`updateDb`, updates, { root: true })
    },

    destroy(
      // eslint-disable-next-line
      { dispatch, rootGetters: {[`battles/battle`]: battle} },
      id
    ) {
      const updates = {
        [`/battleCombatants/${battle}/${id}`]: null,
        [`/combatants/${id}/battles/${battle}`]: null,
      }

      return dispatch(`updateDb`, updates, { root: true })
    },

    async update(
      // eslint-disable-next-line
      { dispatch, getters: {battleIds}, rootGetters: {[`battles/battle`]: battle} },
      { id, ...data }
    ) {
      const updates = {}

      Object.entries(data).forEach(([key, value]) => {
        if (key === `meta`) {
          // avoid overwriting battles object kept at /combatants/[id]/battles
          Object.entries(data.meta).forEach(([key, value]) => {
            updates[`/combatants/${id}/${key}`] = value
          })
        } else {
          // only update battle-specific data
          updates[`/battleCombatants/${battle}/${id}/${key}`] = value
        }
      })

      return dispatch(`updateDb`, updates, { root: true })
    },
  },
}
